import React from 'react'
import { BillboardText, HeaderBlock, colors, useAtSize, Separator } from '@fs/zion-ui'
import { boolAttr } from '@fs/zion-frontend-friends'
import { i18n } from '@fs/zion-locale'
import { useHistory, useLocation } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import i18next from 'i18next'
import image from './assets/landing-family.jpg'
import Search from '../search/Search'
import { getCachedSearchParams, setCachedSearchParams } from '../../services/search-service'

const mainContainerCss = css`
  padding: 24px;
  background-image: linear-gradient(90deg, #a0024caa, #279aadaa), url("${image}");
  background-size: cover;
  background-color: #212121;
  background-position: center 10%;

  /* TEMPORARY: Should be removed once zion-ui WhiteText is updated to handle validation text. This overrides the validation red to white so it is readable. */
  --feedback-danger-text: ${colors.billboard.gray00};
`

const textCss = css`
  display: flex;
  text-align: center;
  max-width: 824px;
  margin: 0 auto;
`

const searchCss = css`
  max-width: 824px;
  margin: 0 auto;
  & header > h5,
  label {
    color: var(--text-reversed);
  }

  & .input-base[status='none']:focus-within label > p > span {
    color: #b3eafc;
  }
`

export default function HomePageHeader(): JSX.Element {
  const [t] = useTranslation()
  const location = useLocation()
  const atSize = useAtSize()
  const isMobile = atSize({ md: false, default: true })
  const history = useHistory()
  const initialParams = getCachedSearchParams()
  const doExternalLink =
    location.pathname.endsWith(`/${i18n.language}`) ||
    location.pathname.endsWith(`/${i18n.language}/`) ||
    window?.location?.hostname === 'localhost'

  function onSearchSubmit(params: Record<string, string>): void {
    setCachedSearchParams(params)
    if (window?.location?.href) {
      history.push(`/${doExternalLink ? i18next.language : 'en'}/search`)
    }
  }

  return (
    <div css={mainContainerCss} is-mobile={boolAttr(isMobile)}>
      <div css={textCss} header-text={boolAttr(true)}>
        <BillboardText primaryColor={colors.text.reversed}>
          <HeaderBlock
            size="lg"
            heading={t('ancestors.page.header', "Find your ancestor in the world's largest shared family tree.")}
            subHeading={t(
              'ancestors.page.subheader',
              'We have over a billion unique profiles in our tree, and growing. See what others have contributed about your ancestors.'
            )}
          />
        </BillboardText>
      </div>
      <Separator size={isMobile ? 'sm' : 'xl'} />
      <div css={searchCss} search-fields={boolAttr(true)}>
        <Search
          params={initialParams}
          header={t('ancestors.search-for-ancestor.header', 'Search For Your Deceased Ancestor')}
          onSubmit={onSearchSubmit}
          analytics={{ link_page: 'Home: Header' }}
        />
      </div>
    </div>
  )
}
